import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {CONFIG} from "../../../app/config";
import {TAction, TFollowup} from "../../../app/enum";
import {LogadoService} from "../../../providers/logado-service";
import {ProfileService} from "../../../providers/profile-service";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {ProfilePagePage} from "../profile-page/profile-page";

@Component({
    selector: 'page-friendy-menu',
    templateUrl: 'friendy-menu.html',
    providers: [ProfileService, ProfileRepository]
})
export class FriendyMenuPage {

    TFollowup: any = TFollowup;

    config: any;
    etapa: number;

    logado: any;

    rootile: any;
    friendys: any;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public logadoService: LogadoService,
                public profileService: ProfileService, public profileRepository: ProfileRepository) {


        this.config = CONFIG;

        this.etapa = this.navParams.get('etapa');
        this.rootile = this.navParams.get('rootile');
        this.logado = this.logadoService.getAuth();

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Friendy Menu', '/friendy-menu');

        this.friendyLoad();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        if (this.etapa == 0) return 'Seguidor';
        if (this.etapa == 1) return 'Seguindo';
        if (this.etapa == 2) return 'Bloqueado';

    }

    friendyLoad() {

        let loading = this.util.loadingDots();
        loading.present();

        let action: TAction;
        if (this.etapa == 0) action = TAction.acLoad;
        if (this.etapa == 1) action = TAction.acList;
        if (this.etapa == 2) action = TAction.acLost;

        this.profileService.friendy(action, this.rootile.Profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {
                    this.friendys = data.Friendys;
                    this.profileRepository.subscribeFollowupChanged(this.friendys).subscribe();
                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    friendyMigo(profile, $event) {

        if ($event) $event.stopPropagation();

        let action: TAction;
        if (this.etapa == 0) action = TAction.acMigo;
        if (this.etapa == 1) action = TAction.acMigo;
        if (this.etapa == 2) action = (profile.FriendyMigo == TFollowup.fwInimigo ? TAction.acLock : TAction.acMigo);

        this.profileRepository.friendy(null, action, profile).subscribe(data => {}, erro => {});

    }

    profilePage(profile, $event) {

        if (this.etapa == 2) return;
        if ($event) $event.stopPropagation();

        let object = {profileID: profile.ProfileID};
        this.util.navActive(this.navCtrl).push(ProfilePagePage, object);

    }

    dismiss() {

        this.navCtrl.pop({animation: 'md-transition'});
        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/friendy-menu/friendy-menu.ts